import { create } from 'zustand';
import type { PresenceEntry } from '@blackboard/shared';

export interface Cursor {
  user_id: string;
  name: string;
  color: string;
  x: number;
  y: number;
  ts: number;
}

interface PresenceState {
  users: Map<string, PresenceEntry>;
  cursors: Map<string, Cursor>;
  highlightUserId: string | null;
  setUsers: (u: PresenceEntry[]) => void;
  addUser: (u: PresenceEntry) => void;
  removeUser: (id: string) => void;
  setCursor: (c: Cursor) => void;
  setHighlight: (id: string | null) => void;
  pruneStale: (olderThanMs: number) => void;
}

export const usePresence = create<PresenceState>((set) => ({
  users: new Map(),
  cursors: new Map(),
  highlightUserId: null,
  setUsers: (us) => set({ users: new Map(us.map((u) => [u.user_id, u])) }),
  addUser: (u) =>
    set((s) => {
      const m = new Map(s.users);
      m.set(u.user_id, u);
      return { users: m };
    }),
  removeUser: (id) =>
    set((s) => {
      const m = new Map(s.users);
      m.delete(id);
      const c = new Map(s.cursors);
      c.delete(id);
      return { users: m, cursors: c };
    }),
  setCursor: (c) =>
    set((s) => {
      const m = new Map(s.cursors);
      m.set(c.user_id, c);
      return { cursors: m };
    }),
  setHighlight: (id) => set({ highlightUserId: id }),
  pruneStale: (olderThanMs) =>
    set((s) => {
      const now = Date.now();
      const m = new Map(s.cursors);
      for (const [k, v] of m) if (now - v.ts > olderThanMs) m.delete(k);
      return { cursors: m };
    }),
}));
